import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { FileUp, Upload, CheckCircle2, HelpCircle } from "lucide-react";

export default function PoukazkyUploadPage() {
  const { user } = useAuth(); // 🔥 nový zdroj pravdy
  const [pharmacyCode, setPharmacyCode] = useState(null);
  const [firma, setFirma] = useState("LEMON");

  const [file, setFile] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!user) return;
    setPharmacyCode(user?.pharmacyCode || null);
    setFirma(user?.firma || "LEMON");
  }, [user]);

  useEffect(() => {
    if (!firma || !pharmacyCode) return;

    (async () => {
      try {
        const res = await fetch(`/api/poukazky-upload/${firma}/${pharmacyCode}/meta`);
        if (res.ok) {
          const data = await res.json();
          setMeta(data);
        }
      } catch (e) {
        console.error("Nelze načíst metadata poukázek:", e);
      }
    })();
  }, [firma, pharmacyCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Vyber soubor poukázky.");
    if (!pharmacyCode) return alert("Chybí pharmacyCode – zkuste se znovu přihlásit.");

    const formData = new FormData();
    formData.append("poukazky", file);

    setIsUploading(true);
    setUploadResult(null);

    try {
      const res = await fetch(`/api/poukazky-upload/${firma}/${pharmacyCode}/poukazky`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Chyba při nahrávání");
      setUploadResult(data);
      setMeta(data);
    } catch (err) {
      alert("Chyba: " + err.message);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-xl font-semibold flex items-center gap-2">
        <FileUp className="w-6 h-6" /> Nahrát poukázky
      </h1>

      {meta ? (
        meta.lastBatch ? (
          <div className="text-sm text-gray-600">
            Poslední nahrání:{" "}
            {new Date(meta.lastBatch).toLocaleString("cs-CZ").replace(/\. /g, ".")}
          </div>
        ) : (
          <div className="text-sm text-rose-600 font-medium">
            Zatím nebyly nahrány žádné poukázky
          </div>
        )
      ) : null}

      <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
        <div className="flex items-center gap-2">
          <label
            className={`flex-1 flex items-center justify-between gap-2 px-4 py-2 rounded-lg border cursor-pointer transition-colors ${
              file
                ? "bg-green-50 border-green-400 text-green-700"
                : "bg-gray-50 border-gray-300 text-gray-700 hover:bg-gray-100"
            }`}
          >
            <div className="flex items-center gap-2 truncate">
              {file ? (
                <>
                  <CheckCircle2 className="w-4 h-4 text-green-600" />
                  <span className="truncate">{file.name}</span>
                </>
              ) : (
                <>
                  <Upload className="w-4 h-4" />
                  <span>Vybrat soubor – poukazky.xls</span>
                </>
              )}
            </div>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
              className="hidden"
            />
          </label>

          <div className="relative group">
            <HelpCircle className="w-5 h-5 text-gray-500 cursor-pointer" />
            <div className="absolute left-6 top-1/2 -translate-y-1/2 w-72 bg-white text-gray-700 text-sm border rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity p-3 z-10">
              Exportujte poukázky ze systému → Uložit jako → poukazky.xls
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={isUploading}
          className="w-full mt-4 px-4 py-4 bg-green-700 hover:bg-green-800 text-white font-medium rounded-lg transition-colors"
        >
          {isUploading ? "Nahrávám…" : "Nahrát poukázky"}
        </button>
      </form>

      {uploadResult?.message && (
        <div className="text-sm text-green-700 bg-green-100 border border-green-300 rounded p-3">
          {uploadResult.message} (celkem {uploadResult.count})
        </div>
      )}
    </div>
  );
}
